import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/styles/prosemirror.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/katex@0.16.20/node_modules/katex/dist/katex.min.css");
